import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class GenericTitleResolver  {
  private titleService = inject(Title);

  resolve(route: ActivatedRouteSnapshot): string {
    const title = route.data.genericTitle;
    this.titleService.setTitle(title);
    return title;
  }
}
